import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService } from 'src/app/services/app-config.service';
import { InitializationService } from 'src/app/services/initialization.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
})
export class RedirectComponent implements OnInit {
  constructor(
    private initializationservice: InitializationService,
    private appconfigservice: AppConfigService,
    private route: ActivatedRoute,
    private router: Router,
    private title: Title,
    public alertDialog: MatDialog
  ) {}

  public messageString: string = '';
  public isError: boolean = false;

  errortitle = 'Ops';
  errormessage = 'Er...';
  errorbutton = '!!!';

  async ngOnInit() {
    try {
      var param = this.route.snapshot.paramMap.get('appname');

      if (param !== null && param !== undefined && param !== '') {
        let result = await this.initializationservice.Initialize(param);

        if (result) {
          var placeName = this.appconfigservice.getPlaceName();

          this.title.setTitle(placeName);

          var appname = this.route.snapshot.paramMap.get('appname');

          var type = this.route.snapshot.paramMap.get('type');

          var uid = this.route.snapshot.paramMap.get('uid');

          if (type === 'combo')
            this.router.navigateByUrl(
              '/' + appname + '/combo/' + uid + '?status=new&isredirect=true'
            );

          if (type === 'item')
            this.router.navigateByUrl(
              '/' + appname + '/menuitem/' + uid + '?status=new&isredirect=true'
            );
        }
      }
    } catch (error) {
      console.error(error);

      this.isError = true;
    }
  }

  setMessages() {
    var locale = this.getUsersLocale('pt');

    switch (locale) {
      case 'pt':
        this.errortitle = 'Ops';
        this.errormessage =
          'Algo deu errado, verifique sua conexão e tente novamente.';
        this.errorbutton = 'Tentar Novamente';
        this.messageString = 'Aguarde...';
        break;
      case 'en':
        this.errortitle = 'Ops';
        this.errormessage =
          'Something went wrong, verify your conection and try again.';
        this.errorbutton = 'Try Again';
        this.messageString = 'Wait...';
        break;
      default:
        this.errortitle = 'Ops';
        this.errormessage =
          'Something went wrong, verify your conection and try again.';
        this.errorbutton = 'Try Again';
        this.messageString = 'wait...';
        break;
    }
  }

  getUsersLocale(defaultValue: string): string {
    if (
      typeof window === 'undefined' ||
      typeof window.navigator === 'undefined'
    )
      return defaultValue;

    const wn = window.navigator as any;

    let lang = wn.languages ? wn.languages[0] : defaultValue;

    lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;

    let langString = String(lang);

    let dashIndx = langString.indexOf('-');

    if (dashIndx > -1) langString = langString.split('-', 2)[0];

    return langString;
  }
}
